// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: dark;
  --surface: #0f172a;
  --surface-strong: #1e293b;
  --border: #334155;
  --text: #e2e8f0;
  --muted: #94a3b8;
  --muted-strong: #cbd5e1;
  --secondary-color: #4f46e5;
  --button-bg: var(--secondary-color);
  --button-border: var(--secondary-color);
  --button-text: #ffffff;
  /* server-card accent gradient — adjustable from WebsiteConfig */
  --accent-start: #22d3ee;
  --accent-end: #34d399;
  /* session progress bar gradient */
  --progress-start: #10b981;
  --progress-end: #22d3ee;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--surface);
  color: var(--text);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

html,
body,
#root {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* ── Global form element styles for the admin frontend ─────────────────────── */
input[type='text'],
input[type='number'],
input[type='email'],
input[type='password'],
input[type='datetime-local'],
input[type='search'],
select,
textarea {
  background: var(--surface-strong);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 13px;
  font-family: inherit;
  width: 100%;
}

input[type='text']:focus,
input[type='number']:focus,
input[type='email']:focus,
input[type='password']:focus,
input[type='datetime-local']:focus,
input[type='search']:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: var(--button-border);
}

/* ── Shared button styles ───────────────────────────────────────────────────── */
.primary-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  background: var(--button-bg);
  color: var(--button-text);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.primary-button:hover {
  opacity: 0.88;
}

.primary-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,mCAAmC;EACnC,uCAAuC;EACvC,sBAAsB;EACtB,gEAAgE;EAChE,uBAAuB;EACvB,qBAAqB;EACrB,kCAAkC;EAClC,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;;AAEA;;;EAGE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA,iFAAiF;AACjF;;;;;;;;EAQE,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;;;;;;;;EAQE,aAAa;EACb,kCAAkC;AACpC;;AAEA,kFAAkF;AAClF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[":root {\r\n  color-scheme: dark;\r\n  --surface: #0f172a;\r\n  --surface-strong: #1e293b;\r\n  --border: #334155;\r\n  --text: #e2e8f0;\r\n  --muted: #94a3b8;\r\n  --muted-strong: #cbd5e1;\r\n  --secondary-color: #4f46e5;\r\n  --button-bg: var(--secondary-color);\r\n  --button-border: var(--secondary-color);\r\n  --button-text: #ffffff;\r\n  /* server-card accent gradient — adjustable from WebsiteConfig */\r\n  --accent-start: #22d3ee;\r\n  --accent-end: #34d399;\r\n  /* session progress bar gradient */\r\n  --progress-start: #10b981;\r\n  --progress-end: #22d3ee;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: var(--surface);\r\n  color: var(--text);\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\nhtml,\r\nbody,\r\n#root {\r\n  height: 100%;\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* ── Global form element styles for the admin frontend ─────────────────────── */\r\ninput[type='text'],\r\ninput[type='number'],\r\ninput[type='email'],\r\ninput[type='password'],\r\ninput[type='datetime-local'],\r\ninput[type='search'],\r\nselect,\r\ntextarea {\r\n  background: var(--surface-strong);\r\n  color: var(--text);\r\n  border: 1px solid var(--border);\r\n  border-radius: 6px;\r\n  padding: 8px 10px;\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n  width: 100%;\r\n}\r\n\r\ninput[type='text']:focus,\r\ninput[type='number']:focus,\r\ninput[type='email']:focus,\r\ninput[type='password']:focus,\r\ninput[type='datetime-local']:focus,\r\ninput[type='search']:focus,\r\nselect:focus,\r\ntextarea:focus {\r\n  outline: none;\r\n  border-color: var(--button-border);\r\n}\r\n\r\n/* ── Shared button styles ───────────────────────────────────────────────────── */\r\n.primary-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 18px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: var(--button-bg);\r\n  color: var(--button-text);\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.primary-button:hover {\r\n  opacity: 0.88;\r\n}\r\n\r\n.primary-button:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
